export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_CessationDate') || '停产日期',
    field: 'cessationDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    required: 'validRules',
    sortable: true,
    sortType: 'string',
    editRender: {
      name: 'ElDatePicker',
      props: {
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
]
